import { DoNotDisturbAltOutlined } from '@mui/icons-material';
import { useState } from 'react';
import { openNotification } from '../../../../helpers/notification';
import { deactivateConsultant } from '../../../../helpers/api';
import ConsultantConfirmDialog, { getConsultantName } from './ConsultantConfirmDialog';

export default function DeactivateConsultant({ open, onClose, consultant }) {
  const [saving, setSaving] = useState(false);

  const handleDeactivate = async () => {
    setSaving(true);
    try {
      const res = await deactivateConsultant(consultant?.userId);
      const { status } = res?.result || {};
      openNotification({
        type: 'success',
        message: status?.desc || `${getConsultantName(consultant)} has been deactivated.`,
      });
      onClose();
    } catch (error) {
      const errmsg =
        error?.data?.result?.status?.desc ||
        error?.data?.result?.desc ||
        error?.result?.status?.desc ||
        'Unable to deactivate this consultant.';
      openNotification({ type: 'error', message: errmsg });
    } finally {
      setSaving(false);
    }
  };

  return (
    <ConsultantConfirmDialog
      open={open}
      onClose={onClose}
      consultant={consultant}
      color="#ed6c02"
      icon={<DoNotDisturbAltOutlined />}
      title="Deactivate consultant?"
      description="Their account will be marked inactive."
      consequences={['You can activate them again at any time from this page.']}
      confirmLabel={saving ? 'Deactivating…' : 'Deactivate'}
      onConfirm={handleDeactivate}
      saving={saving}
    />
  );
}
